import { html, SYSConfig } from "../../../"
import { FormSummaryValidationTextGet } from "../../../../ovlsyscomponents/sysdefaulthtmlsnippets01"
import {
  HookFormSummaryValidationTextDisplay,
  HookFormSummaryValidationTextDisplay_ReturnType,
  HookFormSummaryValidationTextDisplay_Type,
} from "../../../global/hooks"
import { SYSBaseElement } from "../../sysbaseelement"
import { FieldIsFocused } from "../fieldapi"
import { FormHasVisibleSummaryErrors } from "../formapi"
import { FormValidationDisplayType } from "../validators"

export class SYSFormValidationHint extends SYSBaseElement {
  props: any
  formValidationSummaryTextDisplayHook: any

  async init() {
    this.formState = this.props(this.state)
    this.formValidationSummaryTextDisplayHook =
      this.actions.app.global.hooks?.[
        HookFormSummaryValidationTextDisplay.replace(
          "{subFeature}",
          this.formState.subFeature
        )
      ]
    await super.init()
  }
  async getUI() {
    // if (this.formState.locked || !FormHasVisibleSummaryErrors(this.formState)) {
    //   return html`<!---->`
    // }

    let tabErrors =
      this.formState.validationResult[this.formState._state._activeEditTab]
    var relevantErrors = tabErrors.fieldErrors
      .concat(
        Object.keys(tabErrors.validationKeyErrors)
          .map((m) => tabErrors.validationKeyErrors[m])
          .concat(
            Object.keys(tabErrors.summaryErrors).map(
              (m) => tabErrors.summaryErrors[m]
            )
          )
      )
      .filter((f) => {
        if (f.involvedFieldKeys) {
          f.involvedFieldKeysMinusFocused = f.involvedFieldKeys.filter(
            (f) =>
              !(
                FieldIsFocused(this.formState.fields[f]) &&
                !SYSConfig.formDefaults.showErrorWhileTyping
              )
          )
        } else {
          // its a summary type
          return true
        }
        return f.displayAlways || f.involvedFieldKeysMinusFocused.length > 0
      })

    let msgs
    if (relevantErrors.length === 0) {
      msgs = undefined
    } else {
      let hookRes: HookFormSummaryValidationTextDisplay_ReturnType
      if (this.formValidationSummaryTextDisplayHook) {
        hookRes = this.formValidationSummaryTextDisplayHook(<
          HookFormSummaryValidationTextDisplay_Type
        >{
          formState: this.formState,
          relevantErrors,
        })
        if (hookRes === undefined) {
          return null
        }
        msgs = hookRes.res
      }
      if (hookRes === undefined) {
        // default impl
        msgs = FormSummaryValidationTextGet(this.formState, relevantErrors).res
      }
    }
    if (!msgs || msgs.length < 1) {
      return null
    }
    return html`
      <div
        class="fadeInControl fd-form-message fd-form-message--error ovl-formcontrol-formvalidation"
      >
        ${msgs}
      </div>
    `
  }
}
